export const getDocumentCount = (state) =>
    state.document.documents.maxCount;